import { Browser } from '@clappr/core'
import { Utils } from '@player/core'
import { Errors, playerStyle, resetStyle, mergeMediaControlPlugins } from '@player/plugins'

const { LocalStorage, getHostname, getHostAndPathName } = Utils
const PlayerSettings = window.WM && window.WM.Settings || {}

const getChromecastAppId = function() {
  if (!PlayerSettings.CastSenders) return
  const host = Object.keys(PlayerSettings.CastSenders).find(host => host === getHostname() || host === getHostAndPathName())
  return host && PlayerSettings.CastSenders[host]
}

export const DEFAULT_OPTIONS = {
  limited: Browser.isFirefox && Browser.isAndroid,
  preferredLevel: LocalStorage.load('selectedlevel', parseInt),
  changeFavicon: false,
  mediacontrol: { plugins: mergeMediaControlPlugins() },
  chromecast: { appId: getChromecastAppId() },
  preload: 'none',
  hlsMinimumDvrSize: 120,
  useDvrControls: false,
  useBackgroundButton: false,
  useHardwareVideoDecoder: false,
  playback: {
    controls: false,
    preload: 'none',
    playInline: true,
    recycleVideo: Browser.isMobile,
  },
  gaAccount: null,
  gaTrackerName: null,
  allowLocation: false,
  disableVideoTagContextMenu: true,
  stretched: false,
  maxQualityLevel: 'max',
  playerExperiments: PlayerSettings.PlayerExperiments || {},
  allowRestrictedContent: PlayerSettings.allowRestrictedContent,
  videoInfo: { inlineEnabled: false, fullscreenEnabled: true },
  includeResetStyle: true,
  customStyle: {
    mainStyle: playerStyle,
    resetStyle,
  },
  customErrors: Errors,
  shouldDeviceUseWebVTT: true,
}
